import { changeAppState, getAppState } from "../../../../common/appState";

export function openPublicUserProfilePanel(targetUserId: number) {
    const { publicUserProfilePanelsState } = getAppState();
    const currentState = publicUserProfilePanelsState.find(
        state => state.targetUserId === targetUserId
    );

    if (currentState) {
        changeAppState(
            "publicUserProfilePanelsState",
            publicUserProfilePanelsState.map(state =>
                state.targetUserId === targetUserId
                    ? { ...state, open: true }
                    : state
            )
        );
        return;
    }

    changeAppState("publicUserProfilePanelsState", [
        ...publicUserProfilePanelsState,
        {
            targetUserId,
            open: true,
        },
    ]);
}
